import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[var(--csd-border)] bg-white">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="font-heading font-extrabold text-lg">CarSaleDoc</div>
          <p className="mt-2 text-[var(--csd-text-secondary)] leading-relaxed">
            Create, sign and send a vehicle bill of sale in minutes.
          </p>
        </div>
        <div>
          <div className="font-semibold mb-3">By state</div>
          <ul className="space-y-2 text-[var(--csd-text-secondary)]">
            <li><Link to="/by-state" className="hover:text-[var(--csd-primary)]">All states</Link></li>
            <li><Link to="/california-car-bill-of-sale" className="hover:text-[var(--csd-primary)]">California</Link></li>
            <li><Link to="/texas-car-bill-of-sale" className="hover:text-[var(--csd-primary)]">Texas</Link></li>
            <li><Link to="/florida-car-bill-of-sale" className="hover:text-[var(--csd-primary)]">Florida</Link></li>
            <li><Link to="/new-york-car-bill-of-sale" className="hover:text-[var(--csd-primary)]">New York</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3">Free tools</div>
          <ul className="space-y-2 text-[var(--csd-text-secondary)]">
            <li><Link to="/builder/new" className="hover:text-[var(--csd-primary)]">Bill of Sale builder</Link></li>
            <li><Link to="/private-sale-car-value-calculator" className="hover:text-[var(--csd-primary)]">Car value calculator</Link></li>
            <li><Link to="/sample-pdf" className="hover:text-[var(--csd-primary)]">View sample PDF</Link></li>
            <li><Link to="/dashboard" className="hover:text-[var(--csd-primary)]">Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3">Legal</div>
          <ul className="space-y-2 text-[var(--csd-text-secondary)] mb-3">
            <li><Link to="/about" className="hover:text-[var(--csd-primary)]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--csd-primary)]">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-[var(--csd-primary)]">Privacy policy</Link></li>
            <li><Link to="/terms" className="hover:text-[var(--csd-primary)]">Terms of service</Link></li>
          </ul>
          <p className="text-xs text-[var(--csd-text-secondary)] leading-relaxed">
            CarSaleDoc is not a law firm and does not provide legal advice. This tool helps
            prepare a general bill of sale. State DMV requirements may vary. Always check
            your local DMV rules before completing a vehicle transfer.
          </p>
        </div>
      </div>
      <div className="border-t border-[var(--csd-border)] py-4 text-center text-xs text-[var(--csd-text-secondary)]">
        © {new Date().getFullYear()} CarSaleDoc. All rights reserved.
      </div>
    </footer>
  );
}
